module.exports = __webpack_public_path__ + "static/media/team-marta.0560c1b1.png";